import React from "react";
import { Route, Routes } from "react-router-dom";
// import LandingPage from "./components/LandingPage/LandingPage";
import Home from "./components/NewLandingPage/LandingPage";
import About from "./components/NewLandingPage/Pages/About";
import NewLegalPage from "./components/NewLandingPage/LegalPage";
import PreRegistration from "./components/LandingPage/PreRegistration";
import LegalPage from "./components/Legal/LegalPage";
import LoginPage from "./components/Login/LoginPage";
import LogoutPage from "./components/Login/LogoutPage";
import BuyerDashboard from "./components/BuyerDashboard/Buyerdashboard";
import PrivateRoute from "./components/privateRoute";
import Confirmation from "./Registration/Confirmation";
import AccountType from "./Registration/AccountType";
import UserNameForm from "./Registration/UserNameForm";
import EmailVerification from "./Registration/EmailVerification";
import AccountRegistration from "./Registration/AccountRegistration";
import PasswordSetUp from "./Registration/PasswordSetUp";
import BusinessLocationForm from "./components/SupplierProfile/BusinessLocationForm";
import BasicInformation from "./components/SupplierProfile/BasicInformation";
import DiversityVerificationForm from "./components/SupplierProfile/DiversityVerificationForm";
import MembershipCertificationsForm from "./components/SupplierProfile/MembershipCertificationsForm";
import RegistrationComplianceForm from "./components/SupplierProfile/RegistrationComplianceForm";
import ServicesCapabilitiesForm from "./components/SupplierProfile/ServicesCapabilitiesForm";
import StatusVerificationForm from "./components/SupplierProfile/StatusVerificationForm";
import TestimonialsReferencesForm from "./components/SupplierProfile/TestimonialsReferencesForm";
import MultiStepForm from "./components/SupplierProfile/MultiStepForm";
import ForgotPassword from "./components/ResetPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import BuyerProfileRegistration from "./components/BuyerProfile/BuyerProfileRegistration";
import RegistrationConfirmation from "./components/BuyerProfile/RegistrationConfirmation";
import SupplierDashboard from "./components/SupplierDashboard/SupplierDashboard";
import InvitationPage from "./components/BuyerProfile/InvitationPage";
import SupplierInstructions from "./components/SupplierProfile/SupplierInstructions";
import LoginRedirectTempPage from "./Registration/LoginRedirectTempPage";
import Management from "./components/BuyerDashboard/Management/Management";
import CreateNewSupplierForm from "./components/BuyerDashboard/Management/CreateNewSupplierForm";
import MappingTable from "./components/BuyerDashboard/Management/MappingTable";
import FullUserProfileComponent from "./components/BuyerDashboard/SellerProfile/FullUserProfileComponent";
import Marketplace from './components/BuyerDashboard/Marketplace/Marketplace'
import BuyerCollaborations from './components/BuyerDashboard/Collaborations/BuyerCollaborations'
import SupplierEngagement from "./components/BuyerDashboard/Management/SupplierEngagement";
import ScoreCardDashboard from "./components/BuyerDashboard/Management/ScoreCardDashboard";
import Admin from "./components/BuyerDashboard/Admin/Admin";
import AdminDashboard from "./components/BuyerDashboard/Admin/AdminDashboard";
import AdminTenants from "./components/BuyerDashboard/Admin/AdminTenants";
import AdminEngagement from "./components/BuyerDashboard/Admin/AdminEngagement";
import AdminSecurity from "./components/BuyerDashboard/Admin/AdminSecurity";
import Dashboard from "./components/BuyerDashboard/Dashboard/Dashboard";
import SupplierRegistration from "./components/BuyerDashboard/SupplierRegistration/SupplierRegistration";
import Settings from "./components/BuyerDashboard/Settings/Settings";
import FormPage from "./components/BuyerDashboard/SupplierRegistration/FormView";
import { Navigate } from "react-router-dom";


const BuyerDashboardRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<BuyerDashboard />}>
      <Route path="management/full-profile" element={<FullUserProfileComponent />} /> 
      <Route path="marketplace" element={<Marketplace />} />
      <Route path="marketplace/full-profile" element={<FullUserProfileComponent />} />
      <Route path="collaborations" element={<BuyerCollaborations />} />
      <Route path="settings" element={<Settings />} />
      <Route path="admin/*" element={<Admin />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="engagement" element={<AdminEngagement />} />
        <Route path="tenants" element={<AdminTenants />} />
        <Route path="security" element={<AdminSecurity />} />
      </Route>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="supplier-registration" element={<SupplierRegistration />} />

      {/* <Route path="supplier-profile-and-engagement" element={<SupplierEngagement />} /> */}
        {/* <Route path="overview" element={<Overview />} /> */}
         {/* <Route path="marketplace" element={<Marketplace />} />
        <Route path="integrations" element={<Integration />} />
        <Route path="collaborations" element={<BuyerCollaborations />} />
        <Route path="integrations" element={<Integration />} />
        <Route path="settings" element={<Settings />} /> */}
        <Route path="management/*" element={<Management />} />
        {/* <Route path="marketplace/full-profile" element={<FullUserProfileComponent />} />
        // <Route path="management/full-profile" element={<FullUserProfileComponent />} /> 
        */}
        <Route
          path="management/create-new-supplier"
          element={<CreateNewSupplierForm />}
        />
        <Route path="management/supplier-profile-and-engagement" element={<SupplierEngagement />} />
        <Route path="management/supplier-score-card" element={<ScoreCardDashboard />} />
        <Route
          path="management/create-new-supplier/mapping-table"
          element={<MappingTable />}
        />
      </Route>
    </Routes>
  );
};

function RoutesConfig() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/early-access-signup" element={<PreRegistration />} />
      <Route path="/legal/:page" element={<LegalPage />} />
      <Route path="/legal-page/:page" element={<NewLegalPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/signup" element={<AccountRegistration/>} />
      <Route path="/account-confirmation" element={<Confirmation />} />
      <Route path="/account-type" element={<AccountType />} />
      <Route path="/supplier-instructions" element={<SupplierInstructions />} />
      <Route path="/user-name" element={<UserNameForm />} />
      <Route path="/verify-email" element={<EmailVerification />} />
      <Route path="/password" element={<PasswordSetUp />} />
      <Route path="/basic-information" element={<BasicInformation />} />
      <Route path="/business-location" element={<BusinessLocationForm />} />
      <Route path="/diversity-verification" element={<DiversityVerificationForm />} />
      <Route path="/membership-certifications" element={<MembershipCertificationsForm />} />
      <Route path="/registration-compliance" element={<RegistrationComplianceForm />} />
      <Route path="/services-capabilities" element={<ServicesCapabilitiesForm />} />
      <Route path="/status-verification" element={<StatusVerificationForm />} />
      <Route path="/testimonials-references" element={<TestimonialsReferencesForm/>} />
      <Route path="/forgot-password" element={<ForgotPassword/>} />
      <Route path="/supplier-profile-registration/:stepSlug" element={<MultiStepForm />} />
      <Route path="/buyer-profile-registration/:stepSlug" element={<BuyerProfileRegistration/>}/>
      <Route path="/reset-password" element={<ResetPassword/>} />
      <Route path="/registration-confirmation" element={<RegistrationConfirmation/>} />
      <Route path="/buyer-profile-registration/invitation-page" element={<InvitationPage/>} />
      <Route path="/welcome-page" element={<LoginRedirectTempPage/>} />
      <Route path="management/full-profile" element={<FullUserProfileComponent />} /> 
      <Route path="/form/:id" element={<FormPage />} />
      {/* Buyer-only access */}
      <Route element={<PrivateRoute allowedRoles={["BUYER"]} />}>
        <Route path="/dashboard/*" element={<BuyerDashboardRoutes />} />
      </Route>

      <Route element={<PrivateRoute allowedRoles={["SUPPLIER"]} />}>
        <Route path="/supplier-dashboard" element={<SupplierDashboard />} />
      </Route>

      {/* Admin-only access */}
      {/* <Route element={<PrivateRoute allowedRoles={["ADMIN"]} />}>
        <Route path="/dashboard/admin" element={<AdminDashboard />} />
      </Route> */}
    </Routes>
  );
}

export default RoutesConfig;


